export default __webpack_public_path__ + "static/media/6C028EC9-00.1a06428e.png";